import React from 'react';
import Button from '$/components/base/Button';
import NextImage from '$/components/NextImage';
import { useCommonStore } from '@/store/useCommonStore';
import { Popover } from 'antd';
import { getEnv, navigate } from '@/common/agents';
import { mtstatTrack } from '$/utils/mtstat';
import preQrCode from '@/assets/pre-qrcode.png';
import betaQrCode from '@/assets/beta-qrcode.png';
import relaseQrCode from '@/assets/release-qrcode.png';
import useIsMobile from '@/hooks/useIsMobile';
import { useOfficialHomeContext } from '@/components/overseaHome/OfficialHomeContext';
import { OFFICIAL_HOME_LOCALIZED_CONTENT } from '@/components/overseaHome/localizedContent';
import MOBILE_ICON from './images/mobilephone.png';
import WEB_ICON from './images/moniter.png';
import styles from './index.module.scss';

/** 按官网请求语言展示创作入口与操作文案。 */
export default function StartCreationBanner() {
  const officialHome = useOfficialHomeContext();
  const isMobile = useIsMobile();
  // 官网 SSR 与客户端共用请求语言，独立渲染时以英文兜底。
  const content = OFFICIAL_HOME_LOCALIZED_CONTENT[officialHome?.languageCode ?? 'en'].startCreationBanner;
  const imageList = [
    'https://titan-img.meitudata.com/roboneo/image/overseahome/image1.png',
    'https://titan-img.meitudata.com/roboneo/image/overseahome/image2.png',
    'https://titan-img.meitudata.com/roboneo/image/overseahome/image3.png',
    'https://titan-img.meitudata.com/roboneo/image/overseahome/image4.png',
    'https://titan-img.meitudata.com/roboneo/image/overseahome/image5.png',
    'https://titan-img.meitudata.com/roboneo/image/overseahome/17cbac4274e19b9bdd146f8bfb0ef46a2e037144 2.png',
  ];

  const toLogin = useCommonStore((state) => state.toLogin);
  const onTryWebApp = () => {
    mtstatTrack('roboneo_official_page_icon_click', { icon_id: 'try_web_app' });
    // 打开登陆弹窗
    toLogin();
  };

  const downloadContent = () => {
    const QR_CODE = {
      development: preQrCode,
      dev: preQrCode,
      pre: preQrCode,
      beta: betaQrCode,
      release: relaseQrCode,
    }[getEnv().ENV];
    return (
      <div className={styles.downloadPopverContent}>
        <div className={styles.qrcodeBox}>
          <img className={styles.qrcode} src={QR_CODE.src} alt="" />
        </div>
      </div>
    );
  };

  const openQrCode = (open: boolean) => {
    if (open) {
      mtstatTrack('roboneo_official_page_icon_click', { icon_id: 'download_app_code' });
      window.mtstat?.track('download_mobile_hover', {});
    }
  };

  const onDownloadMobileApp = () => {
    mtstatTrack('roboneo_open_app_experience_click', { source: 'overseahome' });
    navigate({
      mode: 'url',
      url: getEnv().ENV === 'development' ? '/--mobile/download' : '/download',
      query: {
        from: 'overseahome',
      },
    });
  };

  return (
    <div className={styles.startCreationBanner}>
      <div className={styles.startCreationBannerBgImage} />
      <div className={styles.content}>
        <h2 className={styles.title}>
          {content.title.prefix}
          <span className={styles.titleHighlight}>{content.title.highlight}</span>
          {content.title.suffix}
        </h2>
        <div className={styles.buttons}>
          <Button
            className={styles.buttonTryWebApp}
            type="primary"
            leftIcon={<NextImage src={WEB_ICON.src} alt="web" width={24} height={24} />}
            onClick={onTryWebApp}
          >
            {content.tryOnline}
          </Button>
          {!isMobile && (
          <Popover
            placement="bottom"
            trigger={['hover']}
            overlayClassName="resetPopoverAndArrow"
            content={downloadContent()}
            onOpenChange={openQrCode}
          >
            <div className={styles.downloadBox} style={{ height: '100%' }}>
              <Button className={styles.buttonDownloadMobileApp} type="plain" leftIcon={<NextImage src={MOBILE_ICON.src} alt="mobile" width={24} height={24} />}>{content.downloadMobile}</Button>
            </div>
          </Popover>
          )}

          {isMobile && (
          <Button
            className={styles.buttonDownloadMobileApp}
            type="plain"
            onClick={onDownloadMobileApp}
            leftIcon={(
              <NextImage
                src={MOBILE_ICON.src}
                alt="mobile"
                width={24}
                height={24}
                sizes="24px"
              />
          )}
          >
            {content.downloadMobile}
          </Button>
          )}

        </div>

        <div className={styles.bgImages}>
          {imageList.map((image, index) => (
            <div key={image} className={styles[`bgImage${index + 1}`]}>
              <NextImage sizes="(max-width: 768px) 80px, 160px" width="160" src={image} alt="" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
